import FilterableCell, { getRefId, resolveRef } from '@/widgets/FilterableCell'

export default function GminaTableRow({
	gmina,
	onPowiatFilter,
	onWojewodztwoFilter,
	onNazwaClick,
}) {
	const gminaId = getRefId(gmina)
	const powiat = resolveRef(gmina?.id_powiat, gmina?.id_miasto?.id_powiat)
	const wojewodztwo = resolveRef(
		gmina?.id_wojewodztwo,
		gmina?.id_powiat?.id_wojewodztwo,
		gmina?.id_miasto?.id_powiat?.id_wojewodztwo,
	)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={gminaId}
					label={gmina?.nazwa || '-'}
					onFilter={onNazwaClick}
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell id={powiat.id} label={powiat.label} onFilter={onPowiatFilter} />
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={wojewodztwo.id}
					label={wojewodztwo.label}
					onFilter={onWojewodztwoFilter}
				/>
			</td>
		</tr>
	)
}
